export const hexDataBitterReach = [
  {
    "name": "A1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN1",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO1",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "B2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C2",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "",
    "adventure": null
  },
  {
    "name": "E2",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "F2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "H2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I2",
    "terrain": "sea ice",
    "includes": [],
    "region": "world's end",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "J2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "L2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "N2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "P2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "R2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "T2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "V2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "X2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "world's end",
    "kin": ""
  },
  {
    "name": "Z2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AB2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AC2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AD2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AF2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AH2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AJ2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AL2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM2",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AN2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO2",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "A3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "B3",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D3",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F3",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "icemoor",
    "adventure": "ice cave"
  },
  {
    "name": "G3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H3",
    "terrain": "sea ice",
    "includes": [],
    "region": "",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J3",
    "terrain": "sea ice",
    "includes": [],
    "region": "",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "K3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L3",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N3",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "O3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P3",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "Q3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R3",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "S3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T3",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V3",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "W3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X3",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "elven ruin",
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z3",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "AA3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB3",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "AC3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD3",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF3",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "world's end"
  },
  {
    "name": "AG3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH3",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AI3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ3",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AK3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL3",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "world's end",
    "kin": ""
  },
  {
    "name": "AM3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN3",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "world's end",
    "kin": ""
  },
  {
    "name": "AO3",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A4",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C4",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E4",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": ""
  },
  {
    "name": "F4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G4",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "H4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I4",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": "elven ruin"
  },
  {
    "name": "J4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K4",
    "terrain": "sea ice",
    "includes": [],
    "region": "",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "L4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M4",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "N4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O4",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "P4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q4",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "R4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S4",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "T4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U4",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "V4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W4",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y4",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA4",
    "terrain": "ice cap",
    "includes": [
      "sea ice"
    ],
    "special": [],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "AB4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC4",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AD4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE4",
    "terrain": "ice cap",
    "includes": [
      "sea ice"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AF4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG4",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AH4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI4",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": "",
    "region": "world's end",
    "kin": ""
  },
  {
    "name": "AJ4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK4",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "world's end",
    "kin": ""
  },
  {
    "name": "AL4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM4",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "world's end",
    "kin": ""
  },
  {
    "name": "AN4",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO4",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "A5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "B5",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D5",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F5",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "G5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H5",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J5",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "K5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L5",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "M5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N5",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "O5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P5",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "Q5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R5",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "S5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T5",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "",
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "U5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V5",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "W5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X5",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z5",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB5",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD5",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AE5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF5",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "elven ruin",
    "region": "morma glacier"
  },
  {
    "name": "AG5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH5",
    "terrain": "ice cap",
    "includes": [
      "sea ice"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AI5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ5",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "world's end",
    "kin": ""
  },
  {
    "name": "AK5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL5",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "world's end",
    "kin": ""
  },
  {
    "name": "AM5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN5",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": "",
    "region": "",
    "kin": ""
  },
  {
    "name": "AO5",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A6",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C6",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E6",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "F6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G6",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I6",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "J6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K6",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "L6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M6",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "N6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O6",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "P6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q6",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "R6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S6",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "T6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U6",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "settlement",
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "V6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W6",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y6",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA6",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC6",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AD6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE6",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AF6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG6",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AH6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI6",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "world's end",
    "kin": ""
  },
  {
    "name": "AJ6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK6",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "world's end",
    "kin": ""
  },
  {
    "name": "AL6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM6",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "world's end",
    "kin": ""
  },
  {
    "name": "AN6",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO6",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B7",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D7",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F7",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "G7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H7",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J7",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "K7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L7",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "M7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N7",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "O7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P7",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "Q7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R7",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "S7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T7",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "U7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V7",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "W7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X7",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z7",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB7",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD7",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AE7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF7",
    "terrain": "ice cap",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AG7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH7",
    "terrain": "ice cap",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AI7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ7",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": "settlement",
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AK7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL7",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "world's end",
    "kin": ""
  },
  {
    "name": "AM7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN7",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AO7",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A8",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C8",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E8",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "F8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G8",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I8",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "J8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K8",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "L8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M8",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "N8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O8",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "P8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q8",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the alter mountains",
    "kin": ""
  },
  {
    "name": "R8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S8",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the alter mountains",
    "kin": ""
  },
  {
    "name": "T8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U8",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the alter mountains",
    "kin": ""
  },
  {
    "name": "V8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W8",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y8",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA8",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC8",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AD8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE8",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AF8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG8",
    "terrain": "ice cap",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AH8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI8",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AJ8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK8",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AL8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM8",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AN8",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO8",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B9",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D9",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F9",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "G9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H9",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J9",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "K9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L9",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "M9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N9",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "O9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P9",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "Q9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R9",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the alter mountains",
    "kin": ""
  },
  {
    "name": "S9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T9",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the alter mountains",
    "kin": ""
  },
  {
    "name": "U9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V9",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "W9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X9",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z9",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB9",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD9",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AE9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF9",
    "terrain": "ice cap",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AG9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH9",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AI9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ9",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "region": "trottecsmark",
    "adventure": null
  },
  {
    "name": "AK9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL9",
    "terrain": "sea ice",
    "includes": [
      "tundra"
    ],
    "region": "world's end",
    "special": [],
    "adventure": null
  },
  {
    "name": "AM9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN9",
    "terrain": "sea ice",
    "includes": [
      "tundra"
    ],
    "region": "world's end",
    "special": [],
    "adventure": null
  },
  {
    "name": "AO9",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A10",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C10",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E10",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "icemoor",
    "adventure": "elven ruin"
  },
  {
    "name": "F10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G10",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I10",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "J10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K10",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "L10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M10",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "N10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O10",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "P10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q10",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the alter mountains",
    "kin": ""
  },
  {
    "name": "R10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S10",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the alter mountains",
    "kin": ""
  },
  {
    "name": "T10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U10",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": "ice cave",
    "region": "the alter mountains",
    "kin": ""
  },
  {
    "name": "V10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W10",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y10",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA10",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC10",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AD10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE10",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AF10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG10",
    "terrain": "ice cap",
    "includes": [
      "ocean"
    ],
    "special": [
      "vistra's edge"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AH10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI10",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AJ10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK10",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "trottecsmark",
    "adventure": null
  },
  {
    "name": "AL10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM10",
    "terrain": "tundra",
    "includes": [
      "sea ice"
    ],
    "special": [],
    "region": "wolvenhome",
    "adventure": "elven ruin"
  },
  {
    "name": "AN10",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO10",
    "terrain": "sea ice",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "A11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B11",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D11",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F11",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "G11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H11",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J11",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "K11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L11",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "elven ruin",
    "region": "icemoor"
  },
  {
    "name": "M11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N11",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "O11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P11",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "Q11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R11",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the alter mountains",
    "kin": ""
  },
  {
    "name": "S11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T11",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the alter mountains",
    "kin": ""
  },
  {
    "name": "U11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V11",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "W11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X11",
    "terrain": "ice cap",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z11",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB11",
    "terrain": "ice cap",
    "includes": [
      ""
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD11",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AE11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF11",
    "terrain": "ice cap",
    "includes": [
      ""
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AG11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH11",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AI11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ11",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "trottecsmark",
    "adventure": null
  },
  {
    "name": "AK11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL11",
    "terrain": "ocean",
    "includes": [
      "tundra"
    ],
    "special": ["grifter's cove"],
    "adventure": null,
    "region": "world's end"
  },
  {
    "name": "AM11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN11",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "region": "wolvenhome",
    "adventure": null
  },
  {
    "name": "AO11",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A12",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C12",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E12",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "F12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G12",
    "terrain": "mountains",
    "includes": [],
    "region": "the white peaks",
    "kin": "",
    "special": [],
    "adventure": "ice cave"
  },
  {
    "name": "H12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I12",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "J12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K12",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "L12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M12",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "N12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O12",
    "terrain": "ice cap",
    "includes": [
      ""
    ],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "P12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q12",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "R12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S12",
    "terrain": "ice forest",
    "includes": [],
    "special": [],
    "region": "deadwoods",
    "adventure": null
  },
  {
    "name": "T12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U12",
    "terrain": "ice forest",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "deadwoods",
    "kin": ""
  },
  {
    "name": "V12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W12",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y12",
    "terrain": "ice cap",
    "includes": [
      "riven"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA12",
    "terrain": "ice cap",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC12",
    "terrain": "ice cap",
    "includes": [
      ""
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AD12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE12",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AF12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG12",
    "terrain": "tundra",
    "includes": [],
    "special": [
      "vistra's edge"
    ],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AH12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI12",
    "terrain": "tundra",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AJ12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK12",
    "terrain": "ocean",
    "includes": [
      "tundra"
    ],
    "special": ["grifter's cove"],
    "adventure": null,
    "region": "world's end"
  },
  {
    "name": "AL12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM12",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "wolvenhome",
    "adventure": null
  },
  {
    "name": "AN12",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO12",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "region": "silver coast",
    "adventure": null
  },
  {
    "name": "A13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B13",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D13",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F13",
    "terrain": "mountains",
    "includes": [],
    "region": "the white peaks",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "G13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H13",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "I13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J13",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "K13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L13",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "M13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N13",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "O13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P13",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "Q13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R13",
    "terrain": "ice cap",
    "includes": [
      "mountains",
      "ice forest"
    ],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "S13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T13",
    "terrain": "ice forest",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "deadwoods"
  },
  {
    "name": "U13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V13",
    "terrain": "ice forest",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "deadwoods"
  },
  {
    "name": "W13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X13",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z13",
    "terrain": "ice cap",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB13",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD13",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AE13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF13",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AG13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH13",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AI13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ13",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": "settlement",
    "region": "trottecsmark"
  },
  {
    "name": "AK13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL13",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "wolvenhome",
    "adventure": null
  },
  {
    "name": "AM13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN13",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "region": "wolvenhome",
    "adventure": null
  },
  {
    "name": "AO13",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A14",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C14",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": "elven ruin"
  },
  {
    "name": "D14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E14",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "F14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G14",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I14",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "J14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K14",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "L14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M14",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "N14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O14",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "P14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q14",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "R14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S14",
    "terrain": "ice forest",
    "includes": [],
    "special": [],
    "region": "deadwoods",
    "adventure": null
  },
  {
    "name": "T14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U14",
    "terrain": "ice forest",
    "includes": [],
    "special": [],
    "region": "deadwoods",
    "adventure": null
  },
  {
    "name": "V14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W14",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y14",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA14",
    "terrain": "ice cap",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": "settlement",
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC14",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AD14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE14",
    "terrain": "ice cap",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AF14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG14",
    "terrain": "tundra",
    "includes": [
      "ice cap"
    ],
    "special": [
      "vistra's edge"
    ],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AH14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI14",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "trottecsmark",
    "adventure": null
  },
  {
    "name": "AJ14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK14",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "wolvenhome",
    "adventure": null
  },
  {
    "name": "AL14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM14",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "wolvenhome",
    "adventure": null
  },
  {
    "name": "AN14",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO14",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "region": "silver coast",
    "adventure": null
  },
  {
    "name": "A15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B15",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D15",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F15",
    "terrain": "mountains",
    "includes": [],
    "region": "the white peaks",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "G15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H15",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "I15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J15",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "K15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L15",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "M15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N15",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "O15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P15",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "Q15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R15",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "grimmerpass",
    "adventure": null
  },
  {
    "name": "S15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T15",
    "terrain": "ice forest",
    "includes": [],
    "special": [],
    "region": "deadwoods",
    "adventure": null
  },
  {
    "name": "U15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V15",
    "terrain": "ice forest",
    "includes": [],
    "special": [],
    "region": "deadwoods",
    "adventure": null
  },
  {
    "name": "W15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X15",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z15",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB15",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD15",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AE15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF15",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [
      "vistra's edge"
    ],
    "adventure": "elven ruin",
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AG15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH15",
    "terrain": "tundra",
    "includes": [
      "tundra"
    ],
    "special": [],
    "region": "trottecsmark",
    "adventure": null
  },
  {
    "name": "AI15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ15",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "trottecsmark",
    "adventure": null
  },
  {
    "name": "AK15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL15",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "wolvenhome"
  },
  {
    "name": "AM15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN15",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "wolvenhome",
    "adventure": null
  },
  {
    "name": "AO15",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A16",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C16",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E16",
    "terrain": "mountains",
    "includes": [],
    "region": "the white peaks",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "F16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G16",
    "terrain": "mountains",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I16",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "J16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K16",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "L16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M16",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "N16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O16",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "P16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q16",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "region": "grimmerpass",
    "adventure": null
  },
  {
    "name": "R16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S16",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "grimmerpass",
    "adventure": null
  },
  {
    "name": "T16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U16",
    "terrain": "ice forest",
    "includes": [],
    "special": [],
    "region": "deadwoods",
    "adventure": null
  },
  {
    "name": "V16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W16",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "morma glacier",
    "adventure": null
  },
  {
    "name": "X16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y16",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA16",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC16",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AD16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE16",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [
      "vistra's edge"
    ],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AF16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG16",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "trottecsmark",
    "adventure": null
  },
  {
    "name": "AH16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI16",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "trottecsmark",
    "adventure": null
  },
  {
    "name": "AJ16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK16",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "wolvenhome",
    "adventure": null
  },
  {
    "name": "AL16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM16",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "region": "wolvenhome",
    "adventure": null
  },
  {
    "name": "AN16",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO16",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "region": "silver coast",
    "adventure": null
  },
  {
    "name": "A17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B17",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D17",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F17",
    "terrain": "ice cap",
    "includes": [
      ""
    ],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "G17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H17",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J17",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "K17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L17",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "M17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N17",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "O17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P17",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "grimmerpass",
    "adventure": null
  },
  {
    "name": "Q17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R17",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "grimmerpass"
  },
  {
    "name": "S17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T17",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "grimmerpass",
    "adventure": null
  },
  {
    "name": "U17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V17",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "morma glacier",
    "adventure": "settlement"
  },
  {
    "name": "W17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X17",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z17",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB17",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD17",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [
      "vistra's edge"
    ],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AE17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF17",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "region": "trottecsmark",
    "adventure": null
  },
  {
    "name": "AG17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH17",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "trottecsmark",
    "adventure": null
  },
  {
    "name": "AI17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ17",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "region": "trottecsmark",
    "adventure": null
  },
  {
    "name": "AK17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL17",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "wolvenhome",
    "kin": ""
  },
  {
    "name": "AM17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN17",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": "settlement",
    "region": "wolvenhome",
    "kin": ""
  },
  {
    "name": "AO17",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A18",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C18",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E18",
    "terrain": "mountains",
    "includes": [],
    "region": "the white peaks",
    "kin": "",
    "special": [],
    "adventure": "ice cave"
  },
  {
    "name": "F18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G18",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I18",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "J18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K18",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "L18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M18",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "N18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O18",
    "terrain": "ice cap",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "P18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q18",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "grimmerpass",
    "kin": ""
  },
  {
    "name": "R18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S18",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "grimmerpass",
    "adventure": "ice cave"
  },
  {
    "name": "T18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U18",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "grimmerpass",
    "adventure": null
  },
  {
    "name": "V18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W18",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y18",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA18",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "morma glacier",
    "adventure": null
  },
  {
    "name": "AB18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC18",
    "terrain": "ice cap",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AD18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE18",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": "settlement",
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AF18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG18",
    "terrain": "tundra",
    "includes": [
      "ice cap",
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AH18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI18",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AJ18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK18",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AL18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM18",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AN18",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO18",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "region": "silver coast",
    "adventure": null
  },
  {
    "name": "A19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B19",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D19",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F19",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "G19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H19",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J19",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "K19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L19",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "M19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N19",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "O19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P19",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "Q19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R19",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "ice cave",
    "region": "grimmerpass",
    "kin": ""
  },
  {
    "name": "S19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T19",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "grimmerpass",
    "kin": ""
  },
  {
    "name": "U19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V19",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "W19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X19",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z19",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB19",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD19",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AE19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF19",
    "terrain": "tundra",
    "includes": [
      "tundra",
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AG19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH19",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AI19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ19",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AK19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL19",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AM19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN19",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "region": "silver coast",
    "adventure": null
  },
  {
    "name": "AO19",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A20",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C20",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E20",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "F20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G20",
    "terrain": "high mountains",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I20",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "J20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K20",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "L20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M20",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "N20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O20",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "P20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q20",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "grimmerpass",
    "kin": ""
  },
  {
    "name": "R20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S20",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "grimmerpass",
    "kin": ""
  },
  {
    "name": "T20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U20",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "V20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W20",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y20",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA20",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC20",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AD20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE20",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AF20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG20",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AH20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI20",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AJ20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK20",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AL20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM20",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AN20",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO20",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "region": "silver coast",
    "adventure": null
  },
  {
    "name": "A21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B21",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D21",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "elven ruin",
    "region": "icemoor"
  },
  {
    "name": "E21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F21",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "icemoor",
    "adventure": null
  },
  {
    "name": "G21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H21",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J21",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "K21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L21",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "M21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N21",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": "ice cave",
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "O21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P21",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "Q21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R21",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "grimmerpass",
    "kin": ""
  },
  {
    "name": "S21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T21",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": "elven ruin",
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "U21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V21",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "W21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X21",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z21",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB21",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD21",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AE21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF21",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AG21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH21",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AI21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ21",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AK21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL21",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AM21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN21",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AO21",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A22",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C22",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E22",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "F22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G22",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I22",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "J22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K22",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "L22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M22",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "N22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O22",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "P22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q22",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "R22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S22",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "T22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U22",
    "terrain": "ice cap",
    "includes": [
      "lake"
    ],
    "special": [
      "the midden"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "V22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W22",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y22",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA22",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC22",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AD22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE22",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor"
  },
  {
    "name": "AF22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG22",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AH22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI22",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AJ22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK22",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AL22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM22",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AN22",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO22",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "A23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B23",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D23",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "E23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F23",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "G23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H23",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J23",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "K23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L23",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "M23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N23",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "O23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P23",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "Q23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R23",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "S23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T23",
    "terrain": "mountains",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "U23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V23",
    "terrain": "ice cap",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "W23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X23",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z23",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB23",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD23",
    "terrain": "tundra",
    "includes": [],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AE23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF23",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AG23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH23",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AI23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ23",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AK23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL23",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AM23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN23",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AO23",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A24",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C24",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E24",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "F24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G24",
    "terrain": "high mountains",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I24",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "J24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K24",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "L24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M24",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "N24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O24",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "P24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q24",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "R24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S24",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "T24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U24",
    "terrain": "ice cap",
    "includes": [
      "lake"
    ],
    "special": [
      "the midden"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "V24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W24",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y24",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA24",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC24",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "garme's edge"
    ],
    "adventure": "settlement",
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AD24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE24",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AF24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG24",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AH24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI24",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "trottecsmark",
    "kin": ""
  },
  {
    "name": "AJ24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK24",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AL24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM24",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AN24",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO24",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "A25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B25",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D25",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "E25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F25",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "G25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H25",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J25",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "K25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L25",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "M25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N25",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "O25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P25",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": "settlement",
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "Q25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R25",
    "terrain": "ice cap",
    "includes": [
      "mountains",
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "S25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T25",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "U25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V25",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "W25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X25",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z25",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB25",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD25",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AE25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF25",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AG25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH25",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AI25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ25",
    "terrain": "tundra",
    "includes": [
      "ocean",
      "river"
    ],
    "special": [
      "trotter isles"
    ],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AK25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL25",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AM25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN25",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AO25",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A26",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C26",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E26",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "F26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G26",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": "ice cave"
  },
  {
    "name": "H26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I26",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "icemoor",
    "adventure": null
  },
  {
    "name": "J26",
    "terrain": "--",
    "includes": [],
    "region": "",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "K26",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "L26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M26",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": "ice cave",
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "N26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O26",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "barren hills",
    "adventure": null
  },
  {
    "name": "P26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q26",
    "terrain": "ice cap",
    "includes": [
      "rier"
    ],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "R26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S26",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": "settlement",
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "T26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U26",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "V26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W26",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y26",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA26",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC26",
    "terrain": "ice cap",
    "includes": [
      "tundra"
    ],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AD26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE26",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AF26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG26",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AH26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI26",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": "settlement",
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AJ26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK26",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AL26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM26",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AN26",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO26",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "region": "silver coast",
    "adventure": null
  },
  {
    "name": "A27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B27",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D27",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F27",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "region": "icemoor",
    "special": [],
    "adventure": null
  },
  {
    "name": "G27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H27",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J27",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "K27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L27",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "M27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N27",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "barren hills",
    "adventure": null
  },
  {
    "name": "O27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P27",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "region": "barren hills",
    "adventure": null
  },
  {
    "name": "Q27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R27",
    "terrain": "ice cap",
    "includes": [
      "mountains",
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "S27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T27",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": "ice cave",
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "U27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V27",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "W27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X27",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z27",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "morma glacier",
    "adventure": null
  },
  {
    "name": "AA27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB27",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD27",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor"
  },
  {
    "name": "AE27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF27",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AG27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH27",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AI27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ27",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AK27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL27",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AM27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN27",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AO27",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A28",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C28",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E28",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "F28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G28",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the white peaks"
  },
  {
    "name": "H28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I28",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "J28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K28",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "L28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M28",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "N28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O28",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "P28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q28",
    "terrain": "mountains",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "R28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S28",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "T28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U28",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "morma glacier",
    "adventure": null
  },
  {
    "name": "V28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W28",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y28",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "morma glacier",
    "adventure": null
  },
  {
    "name": "Z28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA28",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "morma glacier",
    "adventure": null
  },
  {
    "name": "AB28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC28",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AD28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE28",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AF28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG28",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AH28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI28",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AJ28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK28",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AL28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM28",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AN28",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO28",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "A29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B29",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": "elven ruin"
  },
  {
    "name": "C29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D29",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F29",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "G29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H29",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "icemoor",
    "adventure": null
  },
  {
    "name": "I29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J29",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "K29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L29",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "M29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N29",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "O29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P29",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "Q29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R29",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "S29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T29",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "U29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V29",
    "terrain": "ice cap",
    "includes": [],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "W29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X29",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z29",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "dragon's grave"
    ],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AA29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB29",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD29",
    "terrain": "tundra",
    "includes": [],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "fallowmoor"
  },
  {
    "name": "AE29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF29",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AG29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH29",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AI29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ29",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AK29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL29",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AM29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN29",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AO29",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A30",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C30",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E30",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "F30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G30",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the white peaks"
  },
  {
    "name": "H30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I30",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "icemoor",
    "adventure": null
  },
  {
    "name": "J30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K30",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "L30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M30",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "N30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O30",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "P30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q30",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "R30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S30",
    "terrain": "ice cap",
    "includes": [
      "mountains",
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "T30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U30",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "V30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W30",
    "terrain": "ice cap",
    "includes": [],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "X30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y30",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA30",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "dragon's grave"
    ],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AB30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC30",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AD30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE30",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AF30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG30",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AH30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI30",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor"
  },
  {
    "name": "AJ30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK30",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AL30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM30",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": "",
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AN30",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO30",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "region": "silver coast",
    "adventure": null
  },
  {
    "name": "A31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B31",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D31",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F31",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": "ice cave",
    "region": "icemoor"
  },
  {
    "name": "G31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H31",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the white peaks"
  },
  {
    "name": "I31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J31",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "icemoor",
    "adventure": null
  },
  {
    "name": "K31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L31",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": "elven ruin",
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "M31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N31",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "O31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P31",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "settlement",
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "Q31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R31",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": "elven ruin",
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "S31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T31",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "U31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V31",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "W31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X31",
    "terrain": "ice cap",
    "includes": [],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "Y31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z31",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "dragon's grave"
    ],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AA31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB31",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD31",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AE31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF31",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "AG31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH31",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AI31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ31",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL31",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AM31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN31",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "region": "silver coast",
    "adventure": null
  },
  {
    "name": "AO31",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A32",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C32",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E32",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "F32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G32",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "H32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I32",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "icemoor",
    "adventure": "ice cave"
  },
  {
    "name": "J32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K32",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "L32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M32",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor",
    "kin": ""
  },
  {
    "name": "N32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O32",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "P32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q32",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "R32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S32",
    "terrain": "ice cap",
    "includes": [],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "T32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U32",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "V32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W32",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "X32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y32",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "Z32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA32",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC32",
    "terrain": "ice cap",
    "includes": [
      "tundra"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AD32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE32",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AF32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG32",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AH32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI32",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AJ32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK32",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AL32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM32",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "region": "silver coast",
    "adventure": null
  },
  {
    "name": "AN32",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO32",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "region": "silver coast",
    "adventure": null
  },
  {
    "name": "A33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B33",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D33",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "region": "icemoor",
    "adventure": null
  },
  {
    "name": "E33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F33",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "G33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H33",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the white peaks"
  },
  {
    "name": "I33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J33",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "icemoor",
    "adventure": null
  },
  {
    "name": "K33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L33",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "icemoor",
    "adventure": null
  },
  {
    "name": "M33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N33",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "O33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P33",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "Q33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R33",
    "terrain": "mountains",
    "includes": [],
    "region": "barren hills",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "S33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T33",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "U33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V33",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "W33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X33",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "Y33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z33",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [
      "garme's edge"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB33",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AC33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD33",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AE33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF33",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AG33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH33",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AI33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ33",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AK33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL33",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AM33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN33",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AO33",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A34",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C34",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E34",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "F34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G34",
    "terrain": "ice cap",
    "includes": [
      ""
    ],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "H34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I34",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "icemoor",
    "adventure": null
  },
  {
    "name": "J34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K34",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "icemoor",
    "adventure": null
  },
  {
    "name": "L34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M34",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "N34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O34",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "P34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q34",
    "terrain": "ice cap",
    "includes": [
      "mountains",
      "ocean"
    ],
    "region": "barren hills",
    "kin": "",
    "special": [
      "the mirror lake"
    ],
    "adventure": "settlement"
  },
  {
    "name": "R34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S34",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "T34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U34",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "V34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W34",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "X34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y34",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA34",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AB34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC34",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AD34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE34",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AF34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG34",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AH34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI34",
    "terrain": "tundra",
    "includes": [
      "ocean",
      "river"
    ],
    "special": [
      "northfall"
    ],
    "adventure": "settlement",
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AJ34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK34",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AL34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM34",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AN34",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO34",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "A35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "B35",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D35",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "E35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F35",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "G35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H35",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "I35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J35",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "region": "icemoor",
    "adventure": null
  },
  {
    "name": "K35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L35",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "M35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N35",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "ice cave",
    "region": "barren hills",
    "kin": ""
  },
  {
    "name": "O35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P35",
    "terrain": "ice cap",
    "includes": [],
    "region": "barren hills",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "Q35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R35",
    "terrain": "tundra",
    "includes": [
      "lake"
    ],
    "region": "barren hills",
    "kin": "",
    "special": [
      "the mirror lake"
    ],
    "adventure": null
  },
  {
    "name": "S35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T35",
    "terrain": "ice cap",
    "includes": [],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "U35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V35",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "region": "morma glacier",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "W35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X35",
    "terrain": "ice cap",
    "includes": [
      "mountains",
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z35",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": "settlement",
    "region": "",
    "kin": ""
  },
  {
    "name": "AA35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB35",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AC35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD35",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AE35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF35",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": "settlement",
    "region": "",
    "kin": ""
  },
  {
    "name": "AG35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH35",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "fallowmoor",
    "kin": ""
  },
  {
    "name": "AI35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ35",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast",
    "kin": ""
  },
  {
    "name": "AK35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL35",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AM35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN35",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AO35",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E36",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the white peaks"
  },
  {
    "name": "F36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G36",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "H36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I36",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "J36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K36",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "L36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M36",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "barren hills",
    "adventure": null
  },
  {
    "name": "N36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O36",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "barren hills",
    "adventure": null
  },
  {
    "name": "P36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q36",
    "terrain": "tundra",
    "includes": [
      "lake"
    ],
    "region": "barren hills",
    "kin": "",
    "special": [
      "the mirror lake"
    ],
    "adventure": null
  },
  {
    "name": "R36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S36",
    "terrain": "mountains",
    "includes": [],
    "region": "barren hills",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "T36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U36",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "V36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W36",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y36",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [
      "kastor's edge"
    ],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "Z36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA36",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AB36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC36",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AD36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE36",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AF36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG36",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AH36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI36",
    "terrain": "tundra",
    "includes": [
      "ocean",
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AJ36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK36",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AL36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM36",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AN36",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO36",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "A37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "B37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F37",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "G37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H37",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "I37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J37",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": "elven ruin",
    "region": "icemoor"
  },
  {
    "name": "K37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L37",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "M37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N37",
    "terrain": "mountains",
    "includes": [],
    "region": "barren hills",
    "special": [],
    "adventure": null
  },
  {
    "name": "O37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P37",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "barren hills",
    "adventure": null
  },
  {
    "name": "Q37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R37",
    "terrain": "ice forest",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "glitterhome",
    "kin": ""
  },
  {
    "name": "S37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T37",
    "terrain": "ice cap",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "U37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V37",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "W37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X37",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "Y37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z37",
    "terrain": "ice cap",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB37",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AC37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD37",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "region": "ashenmark",
    "special": [],
    "adventure": null
  },
  {
    "name": "AE37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF37",
    "terrain": "tundra",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AG37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH37",
    "terrain": "tundra",
    "includes": [
      "river"
    ],
    "special": [],
    "region": "ashenmark",
    "adventure": null
  },
  {
    "name": "AI37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ37",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark"
  },
  {
    "name": "AK37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL37",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AM37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN37",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AO37",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E38",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "F38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G38",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "H38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I38",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "J38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K38",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "L38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M38",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "barren hills",
    "adventure": null
  },
  {
    "name": "N38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O38",
    "terrain": "high mountains",
    "includes": [],
    "region": "the southern range",
    "special": [],
    "adventure": null
  },
  {
    "name": "P38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q38",
    "terrain": "ice forest",
    "includes": [],
    "region": "glitterhome",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "R38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S38",
    "terrain": "ice forest",
    "includes": [],
    "special": [],
    "adventure": "elven ruin",
    "region": "glitterhome",
    "kin": ""
  },
  {
    "name": "T38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U38",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "V38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W38",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "X38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y38",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA38",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "kastor's edge"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC38",
    "terrain": "tundra",
    "includes": [],
    "region": "ashenmark",
    "special": [],
    "adventure": null
  },
  {
    "name": "AD38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE38",
    "terrain": "tundra",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark"
  },
  {
    "name": "AF38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG38",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AH38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI38",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark"
  },
  {
    "name": "AJ38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK38",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "silver coast"
  },
  {
    "name": "AL38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "silver coast",
    "adventure": null
  },
  {
    "name": "AM38",
    "terrain": "mountains",
    "includes": [
      "tundra"
    ],
    "special": [],
    "adventure": "settlement",
    "region": "ashenmark"
  },
  {
    "name": "AN38",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO38",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark"
  },
  {
    "name": "A39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "B39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F39",
    "terrain": "mountains",
    "includes": [
      "ice cap"
    ],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "G39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H39",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "I39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J39",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "K39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L39",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "M39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N39",
    "terrain": "mountains",
    "includes": [],
    "region": "barren hills",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "O39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P39",
    "terrain": "high mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "Q39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R39",
    "terrain": "ice forest",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "glitterhome",
    "kin": ""
  },
  {
    "name": "S39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T39",
    "terrain": "ice cap",
    "includes": [
      "ice forest"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "U39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V39",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "W39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X39",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "Y39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z39",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "elven ruin",
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB39",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AC39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD39",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AE39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF39",
    "terrain": "tundra",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AG39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH39",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark"
  },
  {
    "name": "AI39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ39",
    "terrain": "tundra",
    "includes": [
      "ocean"
    ],
    "special": [],
    "adventure": "settlement",
    "region": "ashenmark"
  },
  {
    "name": "AK39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL39",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the raven strait"
  },
  {
    "name": "AM39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN39",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "ashenmark",
    "adventure": null
  },
  {
    "name": "AO39",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A40",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "D40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E40",
    "terrain": "high mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "F40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G40",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I40",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "J40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K40",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "L40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M40",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": "ice cave"
  },
  {
    "name": "N40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O40",
    "terrain": "high mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "P40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q40",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "R40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S40",
    "terrain": "ice forest",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "glitterhome",
    "kin": ""
  },
  {
    "name": "T40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U40",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "V40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W40",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "X40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y40",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA40",
    "terrain": "tundra",
    "includes": [],
    "special": [
      "kastor's edge"
    ],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "AB40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC40",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AD40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE40",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AF40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG40",
    "terrain": "tundra",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AH40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI40",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark"
  },
  {
    "name": "AJ40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK40",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AL40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM40",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the raven strait"
  },
  {
    "name": "AN40",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO40",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark"
  },
  {
    "name": "A41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "B41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "C41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D41",
    "terrain": "--",
    "includes": [],
    "region": "",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "E41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F41",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "G41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H41",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J41",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "K41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L41",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "M41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N41",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "O41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P41",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "Q41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R41",
    "terrain": "ice cap",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "S41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T41",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "U41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V41",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "elven ruin",
    "region": "morma glacier"
  },
  {
    "name": "W41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "X41",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z41",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB41",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AC41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD41",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AE41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF41",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AG41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH41",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AI41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ41",
    "terrain": "tundra",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark"
  },
  {
    "name": "AK41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL41",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AM41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN41",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark"
  },
  {
    "name": "AO41",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A42",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E42",
    "terrain": "high mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "F42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G42",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I42",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "J42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K42",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "L42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M42",
    "terrain": "mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "N42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O42",
    "terrain": "high mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "P42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q42",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "R42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S42",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "T42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U42",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W42",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "X42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y42",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA42",
    "terrain": "ice cap",
    "includes": [],
    "special": [
      "kastor's edge"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC42",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AD42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE42",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AF42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG42",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AH42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI42",
    "terrain": "tundra",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AJ42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK42",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "AL42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM42",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the raven strait"
  },
  {
    "name": "AN42",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO42",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark"
  },
  {
    "name": "A43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "B43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F43",
    "terrain": "ice cap",
    "includes": [
      "mounntains"
    ],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "G43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H43",
    "terrain": "mountains",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": "ice cave"
  },
  {
    "name": "I43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J43",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "K43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L43",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "M43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N43",
    "terrain": "mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "O43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P43",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "Q43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R43",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "S43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T43",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "U43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V43",
    "terrain": "ice cap",
    "includes": [
      ""
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "W43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X43",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z43",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB43",
    "terrain": "tundra",
    "includes": [
      "ice cap"
    ],
    "special": [
      "kastor's edge"
    ],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "AC43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD43",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AE43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF43",
    "terrain": "tundra",
    "includes": [],
    "special": [
      "kastor's edge"
    ],
    "adventure": "settlement",
    "region": "",
    "kin": ""
  },
  {
    "name": "AG43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH43",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AI43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ43",
    "terrain": "tundra",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "AK43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL43",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AM43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN43",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the raven strait"
  },
  {
    "name": "AO43",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E44",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "F44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G44",
    "terrain": "mountains",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I44",
    "terrain": "tundra",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "J44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K44",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "L44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M44",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "N44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O44",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "P44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q44",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "R44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S44",
    "terrain": "ice cap",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "T44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U44",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W44",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "X44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y44",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA44",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC44",
    "terrain": "tundra",
    "includes": [],
    "special": [
      "kastor's edge"
    ],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "AD44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE44",
    "terrain": "tundra",
    "includes": [
      "mountains"
    ],
    "special": [
      "kastor's edge"
    ],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "AF44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG44",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AH44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI44",
    "terrain": "tundra",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AJ44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK44",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AL44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM44",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AN44",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO44",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the raven strait"
  },
  {
    "name": "A45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "B45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F45",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "G45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H45",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J45",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "K45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L45",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "M45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N45",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "O45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P45",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": "settlement",
    "region": "the southern range"
  },
  {
    "name": "Q45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R45",
    "terrain": "ice cap",
    "includes": [
      "mountains",
      "lake"
    ],
    "special": [
      "the serf's pass"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "S45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T45",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "U45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V45",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "W45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X45",
    "terrain": "ice cap",
    "includes": [
      ""
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z45",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB45",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD45",
    "terrain": "ice cap",
    "includes": [
      "tundra",
      "lake"
    ],
    "special": [
      "kastor's edge"
    ],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "AE45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF45",
    "terrain": "mountains",
    "includes": [
      "ice cap"
    ],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "AG45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH45",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AI45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ45",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AK45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL45",
    "terrain": "tundra",
    "includes": [
      "ice cap",
      "mountains"
    ],
    "special": [],
    "region": "ashenmark",
    "adventure": null
  },
  {
    "name": "AM45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN45",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "AO45",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E46",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "F46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G46",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I46",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "J46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K46",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "L46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M46",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": "elven ruin"
  },
  {
    "name": "N46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O46",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "P46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q46",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "R46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S46",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "T46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U46",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W46",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "X46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y46",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA46",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC46",
    "terrain": "ice cap",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": "elven ruin",
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AD46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE46",
    "terrain": "mountains",
    "includes": [
      "ice cap"
    ],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "AF46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG46",
    "terrain": "tundra",
    "includes": [
      "ice cap"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AH46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI46",
    "terrain": "tundra",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AJ46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK46",
    "terrain": "tundra",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark"
  },
  {
    "name": "AL46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM46",
    "terrain": "mountains",
    "includes": [
      "ice cap"
    ],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AN46",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO46",
    "terrain": "ocean",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the raven strait"
  },
  {
    "name": "A47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "B47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F47",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "elven ruin",
    "region": "icemoor"
  },
  {
    "name": "G47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H47",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "I47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J47",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "K47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L47",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "M47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N47",
    "terrain": "mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "O47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P47",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "Q47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R47",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "S47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T47",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "settlement",
    "region": "morma glacier"
  },
  {
    "name": "U47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V47",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "W47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X47",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z47",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AA47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB47",
    "terrain": "ice cap",
    "includes": [
      "mountains",
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AC47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AD47",
    "terrain": "mountains",
    "includes": [
      "ice cap"
    ],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "AE47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF47",
    "terrain": "mountains",
    "includes": [
      "ice cap"
    ],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "AG47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH47",
    "terrain": "tundra",
    "includes": [
      "mountains",
      "ice cap"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AI47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ47",
    "terrain": "tundra",
    "includes": [
      "mountains",
      "ice cap"
    ],
    "special": [],
    "adventure": null,
    "region": "ashenmark",
    "kin": ""
  },
  {
    "name": "AK47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL47",
    "terrain": "mountains",
    "includes": [
      "ice cap"
    ],
    "special": [],
    "adventure": "elven ruin"
  },
  {
    "name": "AM47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN47",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AO47",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E48",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "F48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G48",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "H48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I48",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "J48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K48",
    "terrain": "ice cap",
    "includes": [],
    "region": "icemoor",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "L48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M48",
    "terrain": "mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": "ice cave"
  },
  {
    "name": "N48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O48",
    "terrain": "mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "P48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q48",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "R48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S48",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "T48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U48",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W48",
    "terrain": "ice cap",
    "includes": [
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "X48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y48",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Z48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA48",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "AB48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC48",
    "terrain": "ice cap",
    "includes": [
      "mountains",
      "lake"
    ],
    "special": [],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "AD48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE48",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "AF48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG48",
    "terrain": "ice cap",
    "includes": [],
    "special": [],
    "adventure": "elven ruin",
    "region": "",
    "kin": ""
  },
  {
    "name": "AH48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI48",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "",
    "kin": ""
  },
  {
    "name": "AJ48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK48",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AL48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM48",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AN48",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AO48",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "A49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "B49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "F49",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "G49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "H49",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "I49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "J49",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "adventure": null,
    "region": "icemoor"
  },
  {
    "name": "K49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "L49",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "kin": "",
    "special": [],
    "region": "icemoor",
    "adventure": null
  },
  {
    "name": "M49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "N49",
    "terrain": "mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "O49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "P49",
    "terrain": "mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "Q49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "R49",
    "terrain": "high mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "S49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "T49",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "U49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "V49",
    "terrain": "ice cap",
    "includes": [
      "mountains",
      "lake"
    ],
    "special": [],
    "region": "morma glacier",
    "adventure": null
  },
  {
    "name": "W49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X49",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [
      "stillmist"
    ],
    "adventure": null,
    "region": "morma glacier",
    "kin": ""
  },
  {
    "name": "Y49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z49",
    "terrain": "mountains",
    "includes": [],
    "special": [
      "stillmist"
    ],
    "region": "morma glacier",
    "adventure": null
  },
  {
    "name": "AA49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AB49",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "AC49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "morma glacier"
  },
  {
    "name": "AD49",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "AE49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AF49",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "AG49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AH49",
    "terrain": "mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "AI49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AJ49",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "AK49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AL49",
    "terrain": "ice cap",
    "includes": [
      "mountains"
    ],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "AM49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AN49",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "AO49",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "the white peaks",
    "adventure": null
  },
  {
    "name": "B50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "C50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "D50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "E50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "region": "the southern range",
    "adventure": null
  },
  {
    "name": "F50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "G50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "H50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "I50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "J50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "K50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "L50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "M50",
    "terrain": "high mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "N50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "O50",
    "terrain": "high mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "P50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Q50",
    "terrain": "high mountains",
    "includes": [],
    "region": "the southern range",
    "kin": "",
    "special": [],
    "adventure": null
  },
  {
    "name": "R50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "S50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "T50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "U50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "V50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "X50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Y50",
    "terrain": "high mountains",
    "includes": [
      "still mist"
    ],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "Z50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AA50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AB50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AC50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range",
    "kin": ""
  },
  {
    "name": "AD50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AE50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AF50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AG50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AH50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AI50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AJ50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AK50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AL50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "AM50",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "AN50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "region": "world's end",
    "adventure": null
  },
  {
    "name": "AO50",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "A51",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "W51",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "X51",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  },
  {
    "name": "Y51",
    "terrain": "--",
    "includes": [],
    "special": [],
    "adventure": null
  },
  {
    "name": "Z51",
    "terrain": "high mountains",
    "includes": [],
    "special": [],
    "adventure": null,
    "region": "the southern range"
  }
]